import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  selectProcessingResultAction,
  selectProcessingResultSectionActivated,
  selectRegistrationResultAction,
} from '@cashier/cashier-data-access';
import { ResultActionContainers } from '@cashier/cashier-model';

export const useIframeContentController = (): {
  showContent: boolean;
} => {
  const processingResultAction = useSelector(selectProcessingResultAction);
  const registrationResultAction = useSelector(selectRegistrationResultAction);
  const isProcessingResultActivated = useSelector(
    selectProcessingResultSectionActivated,
  );

  const resultAction = useMemo(() => {
    return registrationResultAction || processingResultAction;
  }, [processingResultAction, registrationResultAction]);

  const showContent = useMemo(() => {
    return !(
      resultAction &&
      (resultAction.container === ResultActionContainers.IFRAME ||
        resultAction.container === ResultActionContainers.WINDOW ||
        (resultAction.container === ResultActionContainers.PARAMETERS &&
          Boolean(Object.values(resultAction.parameters).length))) &&
      isProcessingResultActivated
    );
  }, [resultAction, isProcessingResultActivated]);

  return { showContent };
};
